import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { GenericLinkModule, MediaModule } from '@spartacus/storefront';
import { FooterSocialLinkComponent } from './footer-social-link.component';

@NgModule({
  declarations: [FooterSocialLinkComponent],
  imports: [
    CommonModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        FooterSocialLinkComponent: {
          component: FooterSocialLinkComponent,
        },
      },
    } as CmsConfig),
    GenericLinkModule,
  ],
})
export class FooterSocialLinkModule {}
